import { Component, effect, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { BottomNavigatorComponent } from "../../components/bottom-navigator/bottom-navigator.component";
import { filter } from 'rxjs';
import { MatRippleModule } from '@angular/material/core';
import { PsychologistService } from '../../services/psychologist.service';
import { Psychologist } from '../../models/psychologists';
import TYPES from '../../constants/types';
import { TranslatePipe } from '@ngx-translate/core';
import { PushService } from '../../services/push.service';
@Component({
  selector: 'app-home',
  imports: [
    RouterModule,
    MatIcon,
    BottomNavigatorComponent,
    MatRippleModule,
    TranslatePipe
],
  templateUrl: './home.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  
  authService: AuthService = inject(AUTH_SERVICE);
  pushService: PushService = inject(PushService);
  psychologistService: PsychologistService<Psychologist> = inject(PsychologistService);
  isGreetings: boolean = false;
  isProfile: boolean = false;
  isHistorical: boolean = false;

  psychologist: WritableSignal<Psychologist | null> = signal(null);

  PROFILES: any;
  PLANS: any;
  STATUS: any;
  STRIPE_STATUS: any;

  constructor(
    private router: Router
  ) {

    effect(() => {
      this.psychologist.set(this.psychologistService.psychologist());
    });

    this.PROFILES = TYPES.DATABASE.PROFILES;
    this.PLANS = TYPES.DATABASE.PLANS;
    this.STATUS = TYPES.DATABASE.STATUS;
    this.STRIPE_STATUS = TYPES.DATABASE.STRIPE_STATUS;

    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      this.isGreetings = e.url.includes('greetings') || (!e.url.includes('profile') && !e.url.includes('historical'));
      this.isProfile = e.url.includes('profile');
      this.isHistorical = e.url.includes('historical');
    });

    const requestProfessionalProfile = localStorage.getItem('requestProfessionalProfile');
    if(requestProfessionalProfile){
      this.router.navigate(['/request-psychologist'], { replaceUrl: true } );
      localStorage.removeItem('requestProfessionalProfile');
    }
  }

  async account() {
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }

    this.router.navigate(['/account']);
  }

  goTo(page: string){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
    
    if(page === 'sos'){
      this.router.navigate(['/sos']);
    }else if( page === 'choose-plan'){
      this.router.navigate(['/choose-a-plan']);
    }else if( page === 'calendar'){
      this.router.navigate(['/calendar']);
    }
  }
}
